/**
 * atomberg-cart-attributes.js
 *
 * Bridges storefront localStorage data (pincode, UTM params) into Shopify cart
 * attributes so they are accessible to the GTM Web Pixel extension on checkout
 * pages (which run in an isolated sandbox with no localStorage access).
 *
 * Attributes written:
 *   atomberg_pincode    — from localStorage('atomberg_pincode')
 *   utm_source          — from localStorage('lt_utm_source')
 *   utm_medium          — from localStorage('lt_utm_medium')
 *   utm_campaign        — from localStorage('lt_utm_campaign')
 *
 * Trigger: on page load (once) + whenever atomberg:pincode-saved fires.
 */
(function () {
  'use strict';

  /** @type {any} */
  var w = window;
  if (w._atombergCartAttrsInit) return;
  w._atombergCartAttrsInit = true;

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign'];

  /** @param {string} key */
  function read(key) {
    try {
      return localStorage.getItem(key) || '';
    } catch (_) {
      return '';
    }
  }

  /**
   * POST /cart/update.js with the current pincode + UTM values.
   * Shopify ignores unchanged attributes, so repeat calls are cheap.
   * @param {string} pincode
   */
  function syncToCart(pincode) {
    /** @type {Record<string, string>} */
    var attrs = { atomberg_pincode: pincode };
    UTM_KEYS.forEach(function (k) {
      attrs[k] = read('lt_' + k);
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).catch(function () {});
  }

  function init() {
    var pincode = read('atomberg_pincode');
    if (pincode) syncToCart(pincode);

    // Re-sync whenever the user checks a new pincode
    document.addEventListener('atomberg:pincode-saved', function (/** @type {any} */ e) {
      var detail = (e && e.detail) || {};
      if (detail.pincode) syncToCart(detail.pincode);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
